import React from 'react'
import "./Header.css"

function Header() {
    return (
        <div className="header">
        </div>
    )
}

export default Header
